<template>
  <div class="new-journal">
    <template v-if="isPreloadCreation">
      <PreloaderOnCreation />
    </template>
    <template v-else>
      <Header />

      <article class="article-redesign" v-if="article" :key="article.id">
        <div class="article-image" :style="{ backgroundImage: 'url(\'' + article.image + '\')' }">
          <div class="article-title-container article-container">
            <div class="article-title-wrapper">
              <div class="article-section">{{ article.category_name }}</div>
              <div class="article-title" v-html="article.card_name || article.name"></div>
            </div>
          </div>
        </div>

        <div class="article-text-container article-container">
          <div class="article-left-block">

            <div class="article-text" v-html="article.preview_text"></div>
            <br>
            <div class="article-text" v-html="article.detail_text"></div>
            <div v-if="article.marquiz && article.category === '12234458'"
              style="text-align: center; margin-bottom: 25px;">
              <a href="#" @click.prevent="marquiz"
                class="marquiz__button marquiz__button_blicked marquiz__button_rounded marquiz__button_shadow">Пройти
                тест</a>
            </div>
          </div>
          <div class="article-right-block">
            <a :href="banner.link" target="_blank" class="article-banner" v-if="banner"
              :style="{ backgroundImage: 'url(\'' + banner.image + '\')' }">
              <span class="article-banner-text" v-html="banner.text"></span>
            </a>
          </div>
        </div>

        <share :article="article" :key="'share_' + article.id" />

        <template v-if="otherArticles && otherArticles.length > 0">
          <hr>
          <div class="other-articles">
            <div class="article-container _desktop">
              <cards-section code="other" title="Вам также может понравиться" :items="otherArticles" />
            </div>
            <div class="_phone also-interested-section">
              <mobile-section-slider code="other-mobile" name="Вам также может понравиться" link="/category/lifehacks"
                :items="otherArticles" :no-gray="false" :no-margin="true" :gray-bg="true" />
            </div>
          </div>
        </template>
        <hr style="margin-top: 0;">

      </article>
    </template>
  </div>
</template>

<script>
import request from "@/api/axios";
import eventsBus from "@/api/events";
import CardsSection from '@/components/newRedesign/CardsSectionNewCopy';
import MobileSectionSlider from '@/components/newRedesign/MobileSectionSliderNewCopy';
import Share from '@/components/base/Share';
import PreloaderOnCreation from '@/components/newRedesign/UI/PreloaderOnCreation';
import Header from '@/components/newRedesign/HeaderNewCopy.vue'


export default {
  head: {
    link: function () {
      return [
        { rel: 'canonical', href: ('https://finsite.me/article/' + this.$route.params.code) }
      ]
    }
  },
  data: () => {
    return {
      article: null,
      otherArticles: [],
      banner: null,
      templates: {
        4: 'simple',
        5: 'emoji',
        // 6: 'double',
        6: 'simple',
        7: 'image',
        8: 'list',
        9: 'quote',
        11: 'number'
      },
      isPreloadCreation: false,

    };
  },
  components: {
    CardsSection,
    MobileSectionSlider,
    Share,
    PreloaderOnCreation,
    Header

  },
  async created() {
    this.isPreloadCreation = true;

    await this.$store.dispatch('onArticle');
    let data = (
      await request({
        action: "get_article",
        options: { code: this.$route.params.code.replace(".html", "") }
      })
    )?.data;
    if (data.status === false) {
      if (this.$route.path !== '/login' && this.$route.path !== '/profile') {
        if (this.$store.state.user === null) {
          this.$router.push({
            name: "login",
            params: { backUrl: this.$route.path }
          });
          this.isPreloadCreation = false;

        } else if (this.$store.state.user.payment.type !== 1 && this.$store.state.user.payment.type !== 2) {
          this.$router.push({
            name: "promo",
            params: {
              activateTele2: true,
              backUrl: this.$route.path,
              phone: this.$store.state.user.phone.original
            }
          });
          this.isPreloadCreation = false;
        } else {
          this.$router.push("/profile");
          this.isPreloadCreation = false;
        }
      }
    } else {
      data.article.image = data.article.image ? this.$config.hostname + data.article.image : '';
      this.article = data.article;

      this.otherArticles = await this.getOtherArticles();
      this.banner = await this.getBanner();
      this.isPreloadCreation = false;

    }
    eventsBus.$emit("page-ready");
    this.isPreloadCreation = false;

  },
  methods: {
    marquiz() {
      this.$nextTick(() => {
        window.Marquiz.showModal(this.article.marquiz);
      });
    },
    async getBanner() {
      let banner = (await request({ action: 'get_article_banner' })).data.banner;
      if (banner) banner.image = this.$config.hostname + banner.image;
      return banner;
    },
    async getOtherArticles() {
      let data = (await request({ action: 'get_articles' })).data;
      if (data && data.articles) {
        return data.articles
          .filter(article => article.id !== this.article.id)
          .sort(() => Math.random() - Math.random()).slice(0, 4)
          .map(item => {
            item.categoryData = data.categories.find(category => category.id === item.category);
            item.url = '/article' + item.url;
            item.template = this.templates[item.template];
            if (item.template === 'list') item.template = 'simple';
            item.original_name = item.name;
            item.name = item.card_name || item.name;
            item.image = this.$config.hostname + item.image;
            return item;
          });
      }
      return [];
    },
    handleClick() {
      if (this.article?.name.startsWith("Тест:")) {
        this.$nextTick(() => {
          //eslint-disable-next-line
          ym(56121682, "reachGoal", "testbutton", { title: this.article.name });
        });
      }
    }
  }
};
</script>

<style scoped>
.article-redesign {
  padding-top: 72px;
}

.article-container {
  max-width: 1092px;
  padding: 0 10px;
  box-sizing: border-box;
  margin: 0 auto;
  position: relative;
}

.article-image {
  height: 464px;
  width: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /*border-radius: 20px;*/
  margin-bottom: 24px;
  position: relative;
}

.article-image:before {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  /*border-radius: 20px;*/
}

.article-title-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 48px;
}

.article-section {
  padding: 6px 14px;
  padding-top: 8px;
  margin-bottom: 8px;
  background-color: #00f2c7;
  color: #fff;
  font-family: Gilroy;
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 12px;
  letter-spacing: 0.1em;
  display: inline-block;
  text-transform: uppercase;
}

.article-title {
  color: #fff;
  font-family: Gilroy;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: 58px;
}

.article-text-container {
  display: flex;
  justify-content: space-between;
}

.article-left-block {
  max-width: 712px;
  flex-grow: 1;
}

.article-right-block {
  max-width: 296px;
  flex-grow: 1;
  position: relative;
}

.article-banner {
  position: sticky;
  top: 112px;
  height: 480px;
  padding: 32px 24px;
  box-sizing: border-box;
  background-size: contain;
  background-repeat: no-repeat;
  display: block;
}

.article-banner-text {
  display: block;
  font-family: Gilroy;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  color: #fff;
}

.article-text {
  font-family: EB Garamond;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 25px;
  letter-spacing: 0em;
  text-align: left;
  padding-top: 16px;
}

@media screen and (max-width: 950px) {

  .article-right-block {
    display: none;
  }

  .article-left-block {
    max-width: 100%;
  }
}

@media screen and (max-width: 650px) {
  .article-redesign {
    padding-top: 145px;
  }

  .article-title-container {
    padding-bottom: 24px;
  }

  .article-image {
    height: 232px;
  }

  .article-title {
    font-family: Gilroy;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 39px;
    letter-spacing: 0em;
    text-align: left;
  }

}
</style>

<style>
html .payment-methods img {
  margin-left: 5px !important;
  margin-right: 5px !important;
}

html a.marquiz__button {
  background-color: #22b491;
  font-family: Gilroy;
  border: none;
  border-radius: 8px;
  color: #fff;
  padding: 16px;
  text-align: center;
  font-size: 16px;
  line-height: 16px;
  width: 250px;
  font-weight: 600;
  box-sizing: border-box;
}

html a.marquiz__button:after {
  display: none;
}

.other-articles .block-header h4 {
  font-weight: bold;
}

html .article-text p {
  margin-bottom: 24px;
}

html .article-text table td {
  border: 1px solid #ccc;
  padding: 5px;
  text-align: center;
}

html .article-text li {
  position: relative;
  padding-left: 14px;
}

html .article-text li:before {
  content: '';
  display: block;
  border-radius: 100%;
  width: 6px;
  height: 6px;
  background: #000;
  position: absolute;
  left: 0;
  top: 11px;
}

html .article-text h1 {
  font-family: Gilroy;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 32px;
}

html .article-text h3 {
  font-family: Gilroy;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: left;
  margin-bottom: 18px;
}

html .article-text img {
  max-width: 100%;
  height: auto;
}

.other-articles {
  padding-top: 30px;
  padding-bottom: 15px;
}

@media screen and (max-width: 650px) {

  .other-articles {
    background: #f5f5f5;
  }

  html .article-text p {
    font-family: EB Garamond;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 25px;
    letter-spacing: 0em;
    text-align: left;
  }
}

._phone {
  display: block;
  overflow: hidden;
}

._desktop {
  display: none;
}

@media only screen and (min-width: 1200px) {

  ._phone {
    display: none;
  }

  ._desktop {
    display: block;
  }
}
</style>
